import React, { useContext } from "react"

import Link from "images/inline/editorial/link.svg"

import { modalContext } from "global/context/sub-contexts/modalContext"

const LinkShare = ({url, clickHandler =function() {}}) => {
  const modal_context = useContext(modalContext) 
  const { setModalContent, toggleModal  } = modal_context || {}

  return (
    <span
      aria-label="Link Copied"
      onClick={() => {
        clickHandler()
        toggleModal("on")
        setModalContent({
          type: "copylinkmodal",
          shareUrl: url
        })
        
      }}
      onKeyUp={(e) => {
        if (e.key === "Enter") {
          clickHandler()
          toggleModal("on")
          setModalContent({
            type: "copylinkmodal",
            shareUrl: url
          })
        }
      }}>
      <Link />
    </span>
  )
}

export default LinkShare
